module.exports = __webpack_public_path__ + "static/img/bannerTree.231c2a04.jpg";